import { Polygon, Tooltip, CircleMarker } from "react-leaflet";

export function TerminalLayer({ terminals, showBerths = true }) {
  if (!terminals?.length) return null;
  return (
    <>
      {terminals.map((t) => (
        <Polygon key={t.terminal_id} positions={t.polygon} pathOptions={{ color: t.colour, weight: 2, fillColor: t.colour, fillOpacity: 0.28 }} eventHandlers={{ mouseover: (e) => e.target.setStyle({ fillOpacity: 0.45 }), mouseout: (e) => e.target.setStyle({ fillOpacity: 0.28 }) }}>
          <Tooltip permanent direction="center" className="terminal-label" opacity={1}>
            <div style={{ textAlign: "center" }} title={t.operator}><div style={{ fontWeight: 700, fontSize: 12, letterSpacing: 0.3 }}>{t.name.toUpperCase()}</div>{t.berths.length > 2 && <div style={{ fontSize: 10, opacity: 0.9 }}>{t.operator}</div>}</div>
          </Tooltip>
        </Polygon>
      ))}
      {showBerths && terminals.flatMap((t) => t.berths.map((b) => (
        <CircleMarker key={`${t.code}-${b.code}`} center={b.position} radius={9} pathOptions={{ color: "#0C1B15", weight: 1.5, fillColor: t.colour, fillOpacity: 1 }}>
          <Tooltip permanent direction="bottom" offset={[0, 6]} className="berth-label" opacity={1}><span style={{ fontFamily: "JetBrains Mono", fontSize: 10, fontWeight: 700, color: t.colour }}>{b.code}</span></Tooltip>
        </CircleMarker>
      )))}
    </>
  );
}

export function TerminalLegend({ terminals, vessels = [] }) {
  if (!terminals?.length) return null;
  const counts = {};
  vessels.forEach((v) => { if (v.terminal?.code) counts[v.terminal.code] = (counts[v.terminal.code] || 0) + 1; });
  return (
    <table className="w-full text-xs" data-testid="terminal-legend">
      <thead className="text-left font-mono text-[10px] uppercase tracking-wider text-slate-500"><tr><th className="pb-1">Terminal</th><th className="pb-1">Berths</th><th className="pb-1">Operator</th><th className="pb-1 text-right">Vessels</th></tr></thead>
      <tbody className="divide-y divide-[#1E3E30]">
        {terminals.map((t) => (
          <tr key={t.terminal_id} data-testid={`terminal-row-${t.code}`}>
            <td className="py-1.5"><span className="mr-2 inline-block h-2.5 w-2.5 rounded-sm align-middle" style={{ background: t.colour }} /><span className="text-slate-100">{t.name}</span></td>
            <td className="py-1.5 font-mono text-slate-300">{t.berths.map((b) => b.code).join(", ")}</td>
            <td className="py-1.5 text-slate-400">{t.operator}</td>
            <td className="py-1.5 text-right font-mono text-slate-100">{counts[t.code] || 0}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
